module.exports = __webpack_public_path__ + "img/51.3bf6c4bd.png";